/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { Box, Typography, Grid, Divider, List, ListItem } from "@mui/material";

import Image from "../components/image/Image";

import img1 from "../resources/images/self-help-group/1.jpg";
import img2 from "../resources/images/self-help-group/2.jpg";
import img3 from "../resources/images/self-help-group/3.jpg";
import img0 from "../resources/images/self-help-group/0.jpg";

import poster1 from "../resources/images/self-help-group/포스터1.jpg";
import poster2 from "../resources/images/self-help-group/포스터2.jpg";
import poster3 from "../resources/images/self-help-group/포스터3.jpg";
import poster4 from "../resources/images/self-help-group/포스터4.jpg";

export default function SelfHelpGroup(props) {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Grid container justifyContent={"space-between"}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "23vw" : "70vw"} mb={1}>
                <Image disabledEffect alt={""} src={img0} ratio={"6/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                width={nowMediaQuery !== "mobile" ? "40vw" : "80vw"}
                height={"100%"}
              >
                <Typography
                  variant="h4"
                  className="bold"
                  textAlign={"center"}
                  letterSpacing={2}
                  fontSize={25}
                >
                  해피인 가족들의 자조공동체 윗말협의회
                </Typography>
                <Typography
                  variant="subtitle1"
                  fontSize={17}
                  sx={{ my: 2 }}
                  textAlign={"center"}
                >
                  해피인 가족들로 시작 한 윗말협의회는 스스로의 가능성을 찾고
                  <br />
                  자신과 이웃. 지역 문제의 해결을 위해 노력하는 자조 조직입니다.
                  <br />
                  <br />
                  윗말협의회 회원들은 직접 취미모임의 리더가 되어 미술 및
                  사진강좌, 자전거여행,
                  <br /> 등산모임, 영화동호회, 동네 청소와 동네 꽃길가꾸기, 돌봄
                  활동 등을 하고 있습니다.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </section>
      <section className="contents">
        <div>
          <Typography variant="h5" color="black" mb={1}>
            <strong className="blue">비전과 목표</strong>
          </Typography>

          <Typography variant="subtitle1" fontSize={17}>
            • 주인의식을 가진 주민이 스스로 행동하고 힘을 모으는 공동체
            <br />
            • 1인가구 중장년 등의 자립과 권익 향상을 위해 활동하는 공동체
            <br />
            • 나와 이웃과 지역의 문제의 해결과 변화를 위해 행동하는 공동체
            <br />
            • 아프고 힘들고 때, 외롭고 도움이 필요할 때 서로 돕고 돌보는 공동체
            <br />
            • 우리끼리, 우리에 의한, 우리를 위한, 우리의 행복을 만들어 가는
            순수한 가족 공동체
            <br />
          </Typography>
        </div>
      </section>
      <section className="contents">
        <Box>
          <Typography variant="h5" sx={{ my: 0 }} color="black">
            <strong className="blue">연혁</strong>
          </Typography>
          <List sx={{ p: 0 }}>
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2025년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 윗말협의회 지도자 워크숍 (11명)
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2024년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 윗말협의회 재능기부 모임 및 활동
                      <br />
                      • 서울시 1인가구지원센터 돌봄 활동가 양성 교육 파견 (3명)
                      <br />
                      • 2024년 당사자 돌봄 활동가 양성 교육 (관악구청 지원사업)
                      <br />
                      • 한국 주민운동교육원 주민지도자 교육 파견 (2명)
                      <br />
                      • 윗말 돌봄활동가 당사자 돌봄 활동 (15명)
                      <br />• 회원 작품전시회 및 송년회
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2023년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 서울대 시각디자인과와 ‘마을기업 준비 프로젝트’ 협력 및
                      발표회
                      <br />
                      • 윗말협의회 성과와 과제. 실천 방향 위한 워크숍 ‘비전
                      2024’
                      <br />
                      • 윗말 회원 ‘주민 리더자교육’ (한국 주민운동교육원)
                      <br />
                      • 회원 작품 전시회 (윗말 아트페어) 및 송년회
                      <br />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2022년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 주민 욕구 조사 설문 워크숍, 주민 욕구 설문지 작성.
                      <br />
                      • 주민 활동가 교육 (20여 명)
                      <br />
                      • 해피인 가족 102명에게 설문지 배부 및 분석 작업
                      <br />• 윗말협의회 창립 준비위원회 조직
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                variant="subtitle1"
                fontSize={17}
                lineHeight={1.4}
                textAlign={"left"}
                px={4}
                borderRadius={10}
                mr={10}
                width={"220px"}
              >
                2021년
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }} my={0.5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                  my={0.5}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "column" }}
                    my={0.5}
                  >
                    <Typography variant="subtitle1" fontSize={17}>
                      • 도시락 받는 해피인 가족들의 주민모임 ‘소행모’ 결성
                      <br />
                      • 마을청소, 꽃길가꾸기 등 활동
                      <br />• 소행모 ‘2021년 서울시 마을관리소 시범사업’ 선정 및
                      활동
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ListItem>
          </List>
        </Box>
      </section>
      <section className="contents">
        <div>
          <Typography variant="h5" mb={1}>
            <strong className="blue">윗말협의회 활동</strong>
          </Typography>
          <Typography variant="subtitle1" fontSize={17}>
            주민들과 함께하는 대화 및 친교, 정보 나눔, 교육. 재능기부 소모임
            활동
          </Typography>
          <Typography variant="subtitle1" fontSize={17} ml={1}>
            • 당사자 돌봄 활동*, 친교의 날, 사진강좌, 미술강좌, 비누.쿠키
            만들기, 영화감상, 문화유적탐방 여행, 동네 꽃길 가꾸기, 독서 모임,
            등산, 자전거 여행, 노래방, 집청소, 무연고사 빈소마련 및 조문
          </Typography>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img1} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                당사자 돌봄
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                동네 꽃길 가꾸기
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img3} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                역사문화 탐방
              </Typography>
            </Grid>
          </Grid>
          <Typography
            variant="subtitle1"
            textAlign={"right"}
            fontSize={17}
            lineHeight={2}
            mb={5}
          >
            * 당사자 돌봄 활동 : 윗말협의회 회원들이 더 어려운 회원을 돌보는
            활동(도시락 배달, 병원 동행, 산책, 대화, 운동 등)
          </Typography>
        </div>
      </section>
      <section className="contents">
        <Typography variant="h5" mb={2}>
          <strong className="blue">활동 홍보포스터</strong>
        </Typography>
        <Grid container justifyContent={"space-between"} mb={2}>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Box width={nowMediaQuery !== "mobile" ? "15vw" : "30vw"} mb={1}>
              <Image disabledEffect alt={""} src={poster1} />
            </Box>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Box width={nowMediaQuery !== "mobile" ? "15vw" : "30vw"} mb={1}>
              <Image disabledEffect alt={""} src={poster2} />
            </Box>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Box width={nowMediaQuery !== "mobile" ? "15vw" : "30vw"} mb={1}>
              <Image disabledEffect alt={""} src={poster3} />
            </Box>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Box width={nowMediaQuery !== "mobile" ? "15vw" : "30vw"} mb={1}>
              <Image disabledEffect alt={""} src={poster4} />
            </Box>
          </Grid>
        </Grid>
      </section>
    </div>
  );
}
